import { motion } from "framer-motion";
import { Heart, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { imgUrl } from "../lib/api";
import { useCart } from "../context/CartContext";
import { useLang } from "../i18n";

export default function ProductCard({ product, index = 0 }) {
  const { addItem, setDrawerOpen, wishlist, toggleWishlist } = useCart();
  const { t, lang } = useLang();
  const wished = wishlist.includes(product.id);
  const firstSize = product.sizes[0];

  const handleAdd = (e) => {
    e.preventDefault();
    addItem(product, firstSize, 1);
    toast.success(t("common.added"));
    setDrawerOpen(true);
  };

  const handleWish = (e) => {
    e.preventDefault();
    toggleWishlist(product.id);
    toast.success(wished ? t("common.wishlist.remove") : t("common.wishlist.add"));
  };

  return (
    <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: index * 0.08 }} data-testid={`product-card-${product.id}`}>
      <Link to={`/prodotto/${product.id}`} className="group block">
        <div className="relative overflow-hidden rounded-sm border border-[#E5D9C8] bg-white">
          <div className="aspect-[4/5] overflow-hidden">
            <img src={imgUrl(product.image)} alt={product.name_it} loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-bark/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <span className="absolute top-3 left-3 bg-parchment/90 backdrop-blur px-2.5 py-1 text-[10px] font-mono uppercase tracking-widest text-amber-800 border border-[#E5D9C8]" data-testid={`product-botanical-${product.id}`}>
            {product.botanical}
          </span>
          <button onClick={handleWish} data-testid={`wishlist-toggle-${product.id}`}
            className={`absolute top-3 right-3 p-2 rounded-full backdrop-blur transition-colors ${wished ? "bg-terra text-parchment" : "bg-parchment/90 text-cocoa/60 hover:text-terra"}`}>
            <Heart size={15} fill={wished ? "currentColor" : "none"} />
          </button>
          <button onClick={handleAdd} data-testid={`quick-add-${product.id}`}
            className="absolute bottom-3 right-3 flex items-center gap-1.5 bg-bark text-parchment text-xs font-medium px-3.5 py-2 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:bg-honey">
            <Plus size={13} /> {t("product.add")}
          </button>
        </div>
        <div className="pt-4 flex items-start justify-between gap-3">
          <div>
            <h3 className="font-serif text-lg font-semibold leading-snug">{lang === "it" ? product.name_it : product.name_en}</h3>
            <p className="text-xs font-mono text-cocoa/50 mt-1">{product.sizes.map((s) => s.label).join(" / ")}</p>
          </div>
          <p className="font-mono text-sm font-semibold text-honey whitespace-nowrap" data-testid={`product-price-${product.id}`}>
            {t("product.from")} €{firstSize.price.toFixed(2)}
          </p>
        </div>
      </Link>
    </motion.div>
  );
}
